import React, { useRef, useEffect, useState } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "./SundarMap.css";
import Footer from "../dashBoard/footer/Footer";
import ReUseableHeader from "../ReUseableHeader/ReUseableHeader";
export default function SundarMap() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng] = useState(74.1763157);
  const [lat] = useState(31.2867443);
  const [zoom] = useState(13);
  const [API_KEY] = useState("udZp6gLjPnqUshg5bzWG");

  useEffect(() => {
    if (map.current) return; //stops map from intializing more than once
    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: `https://api.maptiler.com/maps/streets/style.json?key=${API_KEY}`,
      center: [lng, lat],
      zoom: zoom,
    });
    map.current.addControl(new maplibregl.NavigationControl(), "top-right");
    new maplibregl.Marker({ color: "#FF0000" })
      .setLngLat([74.1763157, 31.2867443])
      .addTo(map.current);
  });

  return (
    <>
      {/* <ReUseableHeader
        head="Sundar Industrial Estate Map"
        subHead1="About Us"
        subHead2="Sundar Industrial  Estate  Map"
      ></ReUseableHeader> */}
      <div className="map-wrap m-0 p-0">
        <div ref={mapContainer} className="map" />
      </div>
      {/* <Footer /> */}
    </>
  );
}
